// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShareCardPopup__copy-link-b753b1 {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.ShareCardPopup__copy-link-icon-b443a0 {
  fill: var(--brand-primary-40);
  margin-inline-end: 6px;
}

.ShareCardPopup__copy-link-text-d44b83 {
  color: var(--brand-primary-40);
  font: var(--font-body-2);
}

.ShareCardPopup__footer-fb12ad {
  height: auto;
  min-height: 72px;
  justify-content: space-between;
}

.ShareCardPopup__submit-btn-b019c0 {
  margin-inline-start: auto;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ShareCardPopup/ShareCardPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,6BAAA;EACA,sBAAA;AACF;;AAEA;EACE,8BAAA;EACA,wBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,8BAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".copy-link {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.copy-link-icon {\n  fill: var(--brand-primary-40);\n  margin-inline-end: 6px;\n}\n\n.copy-link-text {\n  color: var(--brand-primary-40);\n  font: var(--font-body-2);\n}\n\n.footer {\n  height: auto;\n  min-height: 72px;\n  justify-content: space-between;\n}\n\n.submit-btn {\n  margin-inline-start: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"copy-link": `ShareCardPopup__copy-link-b753b1`,
	"copyLink": `ShareCardPopup__copy-link-b753b1`,
	"copy-link-icon": `ShareCardPopup__copy-link-icon-b443a0`,
	"copyLinkIcon": `ShareCardPopup__copy-link-icon-b443a0`,
	"copy-link-text": `ShareCardPopup__copy-link-text-d44b83`,
	"copyLinkText": `ShareCardPopup__copy-link-text-d44b83`,
	"footer": `ShareCardPopup__footer-fb12ad`,
	"submit-btn": `ShareCardPopup__submit-btn-b019c0`,
	"submitBtn": `ShareCardPopup__submit-btn-b019c0`
};
module.exports = ___CSS_LOADER_EXPORT___;
